export const headlineContentRent = [
  {
    title: 'Welche Geräte möchten Sie Mieten?',
    lead: 'Bitte wählen Sie aus, welche Geräte Sie mieten möchten.'
  },
  {
    title: 'Adresse & Versand',
    lead: 'Wie lautet Ihre Adresse',
    back: 'GeräteauswahL'
  },
  {
    title: 'Auftragsübersicht',
    lead: 'Bitte prüfen Sie alle Angaben sorgfältig, bevor Sie den Mietauftrag erteilen.',
    back: 'Zurück zum Formular'
  },
  {
    title: 'Beauftragung Abgeschlossen',
    lead: 'Vielen Dank für Ihr Vertrauen in unseren Service.',
    back: 'Einen Service Beauftragen'
  }
];

export const MAX_STEPS_RENT = 4;
export const STEP_REVIEW_RENT = 3;
export const OPTION_PICKUP = 'Abholung';
export const OPTION_DELIVERY = 'Versand';
